export class Mutex {
  constructor() {
    this.locked = false;
    this.waiters = [];
  }

  async lock() {
    while (this.locked) {
      await new Promise((resolve) => this.waiters.push(resolve));
    }
    this.locked = true;
  }

  unlock() {
    this.locked = false;
    if (this.waiters.length > 0) {
      const next = this.waiters.shift();
      next();
    }
  }
}
